import Component from '@glimmer/component';

import { array } from '@ember/helper';
import LinksTo from 'ember-route-state/components/links-to.gjs';

import ExpandingBlock from 'rise-ui/components/expanding-block.gjs';
import not from 'rise-ui/helpers/not.js';

export default class CatalogSearchResultComponent extends Component {
  <template>
    <div class="c-catalog-search-result c-search-result qa-search-result">
      <ExpandingBlock
        @button={{true}}
        @iconClass="c-catalog-search-result__expander"
        @disabled={{not @record.validItems.length}}
        @disabledAddText="Catalog Record has no Items"
      >
        <:head>
          <h3 class="c-item-title c-catalog-search-result__name qa-search-result-head">
            <LinksTo
              @route={{array "catalog.record" @record.id}}
              class="qa-search-result-link"
            >{{@record.title}}</LinksTo>
            {{#if @record.validItems.length}}
              <span class="c-catalog-search-result__count"
              >({{@record.validItems.length}})</span>
            {{/if}}
          </h3>
          {{#unless @record.validItems.length}}
            <p class="c-catalog-search-result__no-items-hint"
            >No Items associated with this Record</p>
          {{/unless}}
          {{yield}}
        </:head>
        <:body>
          <p class="c-item-summary c-catalog-search-result__description"
          >{{@record.description}}</p>
          <div class="c-catalog-search-result__items">
            {{#each @record.groupedItems.ordered as | groupedItems |}}
              <div class="c-catalog-search-result__item-group">
                <span class="c-catalog-search-result__item-group-type"
                >{{groupedItems.type}}</span>
                <span class="c-catalog-search-result__item-group-items">
                  {{#each groupedItems.items as | item |}}
                    <div class="c-catalog-search-result__item">
                      <span class="c-catalog-search-result__item-title"><LinksTo
                        @route={{array "catalog.record.item" @record.id item.id}}
                      >
                        {{item.title}}
                      </LinksTo></span>
                    </div>
                  {{/each}}
                </span>
              </div>
            {{/each}}
          </div>
        </:body>
      </ExpandingBlock>
    </div>
  </template>
}
